import { jsx as _jsx } from "react/jsx-runtime";
import { FlexBox, Spinner } from '@dixa/lib-shared-habla';
/** Loading spinner component */
export function LoadingScreen() {
    return (_jsx(FlexBox, Object.assign({ justifyContent: "center", alignItems: "center", height: "100%" }, { children: _jsx(Spinner, {}) })));
}
